import React from 'react';
import ArrowButton from '../../../../../img/icon-btn-arrow-right.svg';

const CourseHeroFooter = ({courseDetails}) => {
    return (
        <div className="course-details-hero-footer">
            <div className="container">
                <a href="#dates" className="btn c-btn--purple">Register<span className="btn-arrow"><ArrowButton /></span></a>
                {/* Request More Info Popup */}
                {/* <Popup className="rct-popup-large" trigger={<button className="text-btn-arrow text-btn-arrow--on-dark">Request More Info <span className="link-arrow"><ArrowTxtBtn /></span></button>} position="center center" modal>
                {close => (
                <div>
                    <a className="rct-popup-content__close" onClick={close}><PopupBtnClose /></a>
                    <div className="rtecontent" dangerouslySetInnerHTML={{__html: courseDetails.moreInfoPopup}}/>
                </div>
                )}
                </Popup> */}
            </div>
        </div>
    );
};

export default CourseHeroFooter;